import request from '@/utils/request'

// 帖子模块

// 分页查询帖子列表
export function postList(data) {
  return request({
    url: '/invitation/page',
    method: 'post',
	data: data
  })
}
// 发布帖子和帖子存草稿箱
export function addPost(data) {
  return request({
    url: '/invitation/save',
    method: 'post',
	data: data
  })
}
// 草稿箱
export function cuncaogao(data) {
  return request({
    url: `/invitation/draft?pageNum=${data.pageNum}&size=${data.size}`,
    method: 'get',
  })
}
// 编辑草稿箱
export function editPost(id) {
  return request({
    url: `/invitation/infot/${id}`,
    method: 'get'
  })
}
// 删除草稿箱
export function deletePost(id) {
  return request({
    url: `/invitation/delete/${id}`,
    method: 'post'
  })
}
export function shangwenjian(data) {
  return request({
    url: `upload/file`,
    method: 'post',
	data:data
  })
}
